export default __webpack_public_path__ + "static/media/send.7637b052.svg";